import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, mobileLogo, logoTitle, viewMenu } from 'images'
import ViewMenuButton from './ViewMenuButton'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView row center w="100%" textCenter bg="black">
          <CFView style={{ fontSize: 32 }} white xBold p="12px">
            Sushi Mate
          </CFView>
          <CFView
            center
            br="30px"
            bc="white"
            bw="3px"
            pb="3px"
            ph="13px"
            style={{ fontSize: 22 }}
            white
            xBold
          >
            Langley
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          column
          center
          w="100%"
          zIndex={98}
          h="60px"
          bg="rgba(0,0,0,0.9)"
        >
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFView row alignCenter>
              <CFView style={{ fontSize: 30 }} white xBold ml="15px">
                Sushi Mate
              </CFView>
              <CFView
                center
                br="30px"
                bc="white"
                bw="3px"
                pb="3.5px"
                ph="12px"
                style={{ fontSize: 20 }}
                white
                xBold
                ml="10px"
              >
                Langley
              </CFView>
            </CFView>
            <CFView mt="10px">
              <ViewMenuButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
